/**
 * Extract a human-readable message from an appointments API error.
 *
 * AP-03 (audit 2026-06-16): the settings forms (services/professionals/partners)
 * caught the axios error and showed a generic "An error occurred" toast,
 * discarding the field-level validation messages the backend returns as
 * `{ errors: { name: ["can't be blank"], ... } }`. The store now propagates the
 * original error; this turns it into a readable string the form can display.
 *
 * Returns an empty string when nothing useful is present, so callers can fall
 * back to their generic message.
 */
export function extractServerError(error) {
  const data = error?.response?.data;
  if (!data) return '';

  if (typeof data.error === 'string' && data.error.trim()) return data.error;

  const errs = data.errors;
  if (Array.isArray(errs)) return errs.filter(Boolean).join(', ');
  if (errs && typeof errs === 'object') {
    return Object.values(errs)
      .map(msgs => (Array.isArray(msgs) ? msgs.join(', ') : msgs))
      .filter(Boolean)
      .join('; ');
  }
  if (typeof errs === 'string' && errs.trim()) return errs;

  return '';
}

export default { extractServerError };
